import { FC } from 'react';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

export interface TableCountProps {
	/** Numărul de înregistrări (total din BE sau lungimea listei filtrate). */
	count: number;
	/** Etichetă la singular (count === 1), ex. „administrație". */
	singular: string;
	/** Etichetă la plural, ex. „administrații". */
	plural: string;
	/** Cât timp e true, în locul numărului apare un mic spinner (înainte să vină datele). */
	loading?: boolean;
	sx?: SxProps<Theme>;
}

// Contorul + eticheta afișate deasupra tabelelor (aceeași mărime/culoare ca textul),
// cu un mic spinner cât timp datele se încarcă din BE.
export const TableCount: FC<TableCountProps> = ({ count, singular, plural, loading, sx }) => (
	<Stack
		direction="row"
		sx={{ gap: 0.75, alignItems: 'center', color: 'text.secondary', ...sx }}
	>
		{loading && <CircularProgress size={14} color="inherit" />}
		<Typography variant="body2" sx={{ color: 'text.secondary' }}>
			{loading ? plural : `${count} ${count === 1 ? singular : plural}`}
		</Typography>
	</Stack>
);

TableCount.defaultProps = {
	loading: false,
	sx: undefined
};
